import { ApolloClient, gql } from 'apollo-boost';

export interface ReportRatingFunder {
  name: string;
  email: string;
}

export interface ReportRatingInvestment {
  id: number;
  total: number;
  allocationAmount: number;
  funder: ReportRatingFunder;
}

export interface ReportRatingReport {
  id: number;
  name: string;
  status: string;
  year: number;
  stage: string;
  clonedFromId: number | null;
  cnOptedIn: boolean;
}

export interface ReportRatingItem {
  id: number;
  type: string;
  rating: number;
  description: string;
  createdAt: string;
  userEmail: string;
  report?: ReportRatingReport;
  investments: ReportRatingInvestment[];
}

export interface ReportRatingsListResponse {
  reportRatingsList: {
    total: number;
    page: number;
    perPage: number;
    items: ReportRatingItem[];
  };
}

export interface ReportRatingsFilters {
  userEmail?: string;
  reportId?: number;
  rating?: number;
  hasClonedFromId?: boolean;
  hasCnOptedIn?: boolean;
}

const buildQuery = ({
  userEmail,
  reportId,
  rating,
  hasClonedFromId,
  hasCnOptedIn,
}: ReportRatingsFilters) => gql`
  query reportRatingsList(
    $page: Int!
    $perPage: Int!
    ${userEmail ? '$userEmail: String' : ''}
    ${reportId ? '$reportId: Int' : ''}
    ${rating ? '$rating: Int' : ''}
    ${hasClonedFromId !== undefined ? '$hasClonedFromId: Boolean' : ''}
    ${hasCnOptedIn !== undefined ? '$hasCnOptedIn: Boolean' : ''}
  ) {
    reportRatingsList(
      page: $page
      perPage: $perPage
      ${userEmail ? 'userEmail: $userEmail' : ''}
      ${reportId ? 'reportId: $reportId' : ''}
      ${rating ? 'rating: $rating' : ''}
      ${
        hasClonedFromId !== undefined ? 'hasClonedFromId: $hasClonedFromId' : ''
      }
      ${hasCnOptedIn !== undefined ? 'hasCnOptedIn: $hasCnOptedIn' : ''}
    ) {
      total
      page
      perPage
      items {
        id
        type
        rating
        description
        createdAt
        userEmail
        report { id name status year stage clonedFromId cnOptedIn }
        investments { id total allocationAmount funder { name email } }
      }
    }
  }
`;

export const getReportRatings = (
  client: ApolloClient<object>,
  page: number,
  perPage: number,
  filters: ReportRatingsFilters,
) => {
  const {
    userEmail,
    reportId,
    rating,
    hasClonedFromId,
    hasCnOptedIn,
  } = filters;
  return client.query<ReportRatingsListResponse>({
    query: buildQuery({
      userEmail,
      reportId,
      rating,
      hasClonedFromId,
      hasCnOptedIn,
    }),
    variables: {
      page,
      perPage,
      userEmail,
      reportId,
      rating,
      hasClonedFromId,
      hasCnOptedIn,
    },
    fetchPolicy: 'network-only',
  });
};
